import script from "./KonzeptIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./KonzeptIndex.vue?vue&type=script&setup=true&lang=js"

import "./KonzeptIndex.vue?vue&type=style&index=0&id=8cc170d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cc170d2"]])

export default __exports__